export default __webpack_public_path__ + "static/media/heart-outline.cd3c44c3.svg";